import {
    Button,
    Checkbox,
    DownloadIcon,
    Flex,
    Loader,
    SendIcon,
    Skeleton,
    Text,
} from "@fluentui/react-northstar";
import {
    ClockDismiss24Regular,
    ClipboardCheckmark24Regular,
} from "@fluentui/react-icons";
import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import SliderTabs from "../../../../components/shared/SliderTabs";
import TimeReportingStatus from "../TimeReportingStatus";
import SearchBarEmployeeList from "../SearchBarEmployee";
import TimeReportToValidate from "./TimeReportToValidate";
import { Container, ContainerFluid } from "../../../../common/styles";
import { DialogCancelConfirmation } from "../../../../components/Dialogs/DialogCancelConfirmation";
import Illustration from "../../../../components/shared/Illustration";
import Toast from "../../../../components/Alerts";

import { useSearchParams } from "react-router-dom";
import WeekTableHeader from "../WeekTableHeader";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
    _api_export_time_reporting_selected_user,
    _api_get_all_data_for_my_team,
    _api_get_validate_time_reporting,
    _api_post_validate_time_reporting,
} from "../../api";
import EmptyTable from "./TimeReportToValidate/EmptyTable";
import { BADGE_STATUS } from "../BadgeStatus";
import SliderMonth from "../Sliders/SliderMonth";
import moment from "moment";
import LoadingData from "../../pages/Week/LoadingData";
import ExportButton from "./components/ExportButton";
import { _get_all_employees_and_teams } from "../../../../api/user";
import { useDebounce } from "use-debounce";
import useToastSonner from "../../../../hooks/useToastSonner";

const STATUS_TIME_REPORTING = ["to_approve", "incomplete", "closed"];
const STATUS_COUNTER_LABEL = {
    to_approve: "à valider",
    incomplete: "incomplètes",
    closed: "",
};
const QUERY_KEY_TEAMS = "get_all_data_for_my_team";
const QUERY_KEY_COUNTER_TO_APPROVE = "TIME_REPORTING::counterToApprove";

export const onChangeUser = (
    id_user,
    type,
    data = [],
    setFiltredData,
    setActiveTab,
    addNewParam,
    onChangeSelectedUser
) => {
    const keys = Object.keys(data).filter((i) => i !== "weeks" && i !== "res");
    if (type === "user") {
        for (var i = 0; i < keys.length; i++) {
            const keyValue = keys[i];
            const data_key = data[keyValue];

            const find_user = data_key
                .map((team) => team.users)
                .flat()
                .filter((user) => "u-" + user?.id === id_user);
            if (find_user?.length > 0) {
                setFiltredData(data[STATUS_TIME_REPORTING.at(i)]);
                setActiveTab(i);
            }
        }
    }
    addNewParam({
        id: id_user,
        type,
    });
    // sert a afficher un seul object
    onChangeSelectedUser(id_user, type);
    return;
};

const MyTeam = () => {
    const queryClient = useQueryClient();
    const [searchParams] = useSearchParams();
    const tab = searchParams.get("tab");
    const [activeTab, setActiveTab] = useState(tab ? Number(tab) : 0);
    const [params, setParams] = useSearchParams();
    const [highlightedColumn, setHighlightedColumn] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);

    const [currentMonth, setCurrentMonth] = useState({
        index: params.get("month")
            ? Number(params.get("month") - 1)
            : moment().get("month"),
        name_month: moment().format("MMMM"),
        year: params.get("year")
            ? Number(params.get("year"))
            : moment().get("year"),
    });
    const [filtredData, setFiltredData] = useState([]);
    const [ConfirmationDialog, setConfirmationDialog] = useState(false);
    const [RefuseDialog, setRefuseDialog] = useState(false);
    const [RelanceDialog, setRelanceDialog] = useState(false);
    const [userIdChecked, setUserIdChecked] = useState([]);

    const [configToast, setConfigToast] = useState({
        visible: false,
        level: "success",
        content: "",
    });

    const [debouncedMonth] = useDebounce(currentMonth.index, 400);

    const {
        isFetching,
        isLoading,
        data,
        refetch: refetch_all_data_team,
    } = useQuery(
        ["get_all_data_for_my_team", debouncedMonth],
        () => _api_get_all_data_for_my_team(currentMonth),
        {
            enabled: !!currentMonth,
            refetchOnWindowFocus: false,
            onSuccess: (response) => {
                setFiltredData(response[STATUS_TIME_REPORTING.at(activeTab)]);
                return console.log("tab2 here", filtredData);
            },
        }
    );

    // fetch les utilisateurs et départements du dropdown
    const { data: employees_and_teams, isLoading: is_loading_employees_teams } =
        useQuery(["time_reporting::get_list_employee_and_teams"], () => {
            return _get_all_employees_and_teams();
        });

    const {
        mutate: mutate_validation,
        isLoading: isLoadingValidation_or_RefuseTimeReporting,
    } = useMutation((data) => {
        return _api_post_validate_time_reporting(data);
    });

    const userIdToSend = (id) => {
        if (userIdChecked?.includes(id)) {
            setUserIdChecked((prevIds) =>
                prevIds?.filter((item) => item !== id)
            );
        } else {
            setUserIdChecked((prevCheckedId) => [...prevCheckedId, id]);
        }
    };
    const handleAllCheckbox = (e, { checked }) => {
        if (checked) {
            const all_checked = filtredData
                ?.map((el) => el?.users?.flat().map((u) => u?.id))
                ?.flat();
            setUserIdChecked(all_checked);
        } else {
            setUserIdChecked([]);
        }
    };

    // lorqu'on change le User or departement dans le dropdown
    const onChangeSelectedUser = (id_selected, type = null) => {
        if (!id_selected) {
            return setFiltredData(data[STATUS_TIME_REPORTING.at(activeTab)]);
        }
        // sinon on cherche, selon si c'est département ou employé
        if (type === "user") {
            setFiltredData((state) => {
                const filteredData = findUserById(state, id_selected);
                return filteredData;
            });
        } else {
            // c'est département
            setFiltredData((state) => {
                const filtredData = findDepartmentById(state, id_selected);

                return filtredData;
            });
        }
    };

    const findUserById = (data, userId) => {
        let result = [];
        for (let department of data) {
            let filteredUsers = department.users.filter(
                (user) => "u-" + user.id === userId
            );

            if (filteredUsers.length > 0) {
                result.push({
                    ...department,
                    users: filteredUsers,
                });
            }
        }

        return result;
    };

    const findDepartmentById = (data, departmentId) => {
        let result = [];
        console.log({ data, departmentId });
        for (let team of data) {
            if ("t-" + team.id === departmentId) {
                result.push(team);
                break;
            }
        }

        return result;
    };

    const addNewParam = (newParams) => {
        // Créer une nouvelle instance de URLSearchParams avec les paramètres actuels
        const newSearchParams = new URLSearchParams(params);

        // Ajouter ou mettre à jour le nouveau paramètre
        Object.entries(newParams).forEach(([key, value]) => {
            newSearchParams.set(key, value);
        });

        // Mettre à jour les paramètres de requête dans l'URL
        setParams(newSearchParams);
    };

    // refuser une feuille de temps
    const Refuse_time_reporting = () => {
        mutate_validation(
            { users: userIdChecked, type: "reject", currentMonth },
            {
                onSuccess: (data) => {
                    if (data?.success) {
                        setConfigToast({
                            visible: true,
                            level: "warning",
                            content:
                                "Feuille(s) de temps refusée(s) - Réouverture à la saisie",
                        });
                        // setConfirmationDialog(false);
                        setUserIdChecked([]);
                        setRefuseDialog(false);
                        return refetch_all_data_for_my_team();
                    } else {
                        setConfigToast({
                            visible: true,
                            level: "danger",
                            content: "error reject request",
                        });
                    }
                },
            }
        );
    };

    // valider une feuille de temps
    const Validate_time_reporting = () => {
        mutate_validation(
            { users: userIdChecked, type: "approve", currentMonth },
            {
                onSuccess: (data) => {
                    if (data?.success) {
                        setConfigToast({
                            visible: true,
                            level: "success",
                            content: "Feuille de temps approuvée",
                        });
                        setUserIdChecked([]);
                        setConfirmationDialog(false);
                        return refetch_all_data_for_my_team();
                    }
                },
            }
        );
    };

    // relancer la feuille de temps
    const Relance_time_reporting = () => {
        mutate_validation(
            { users: userIdChecked, type: "remind", currentMonth },
            {
                onSuccess: (data) => {
                    if (data?.success) {
                        setConfigToast({
                            visible: true,
                            level: "success",
                            content: "Feuille de temps relancée",
                        });
                        // setConfirmationDialog(false);
                        setRelanceDialog(false);
                        return refetch_all_data_for_my_team();
                    }
                },
            }
        );
    };

    const path = userIdChecked?.map((checkedId) => `u=${checkedId}`).join("&");
    const isLoadingData = isLoading || isFetching;

    const {
        isLoading: isLoadingExportSelectedUser,
        isFetching: isFetchingExportSelectedUser,
        data: ExportedData,
        refetch: refetchDownload,
    } = useQuery(["ExportSelectedUser"], () => {
        () => ExportSelectedData();
    });

    const onDownloadSuccess = () => {
        return setIsDownloading(false);
    };

    const ExportSelectedData = async () => {
        setIsDownloading(true);
        await _api_export_time_reporting_selected_user({
            path,
            currentMonth,
            onDownloadSuccess,
        });
        return;
    };

    const refetch_all_data_for_my_team = () => {
        refetch_all_data_team();
        queryClient.refetchQueries([QUERY_KEY_COUNTER_TO_APPROVE]);
        return queryClient.refetchQueries([QUERY_KEY_TEAMS]);
    };

    // const onActiveTabChanged = (value) => {
    //     console.log("tab changed", value);
    //     setUserIdChecked([]);
    //     setActiveTab(value);

    //     if (isLoading || isFetching) {
    //         return;
    //     }
    //     const new_params = new URLSearchParams(params);
    //     new_params.delete("id");
    //     new_params.delete("type");
    //     setParams(new_params);
    //     return setFiltredData(data[STATUS_TIME_REPORTING.at(value)]);
    // };
    const onActiveTabChanged = (value) => {
        setUserIdChecked([]);
        setActiveTab(value);

        const new_params = new URLSearchParams(params);
        new_params.set("tab", value);
        const user_id = params.get("id");
        if (user_id?.startsWith("u-")) {
            new_params.delete("id");
            new_params.delete("type");
            // setParams(new_params);
            return setFiltredData(data[STATUS_TIME_REPORTING.at(value)]);
        } else if (user_id?.startsWith("t-")) {
            const dataTab = data[STATUS_TIME_REPORTING.at(value)];
            const filtredData = findDepartmentById(dataTab, user_id);
            setFiltredData(filtredData);
            return;
        } else {
            new_params.delete("id");
            new_params.delete("type");
            // setParams(new_params);
            setFiltredData(data[STATUS_TIME_REPORTING.at(value)]);
        }
        setParams(new_params);
    };

    const changeMonth = (type) => {
        const momentYear = moment()
            .year(currentMonth.year)
            .month(currentMonth.index);
        // supprimer les users selectionnes lors du changement du mois.
        setUserIdChecked([]);
        if (type === "increment") {
            const momentMonthYear = momentYear.add(1, "months");
            setCurrentMonth({
                index: momentMonthYear.month(),
                name_month: momentMonthYear.format("MMMM"),
                year: momentMonthYear.year(),
            });
            return;
        }
        if (type === "decrement") {
            const momentMonthYear = momentYear.add(-1, "months");
            setCurrentMonth({
                index: momentMonthYear.month(),
                name_month: momentMonthYear.format("MMMM"),
                year: momentMonthYear.year(),
            });
            return;
        }
    };

    // Fonction pour calculer le nombre total de fils (utilisateurs)
    const countTotalUsers = (departments) => {
        let totalUsers = 0;
        if (!departments?.length) return 0;
        departments.forEach((department) => {
            if (department.users && Array.isArray(department.users)) {
                totalUsers += department.users.length;
            }
        });

        return totalUsers;
    };

    useEffect(() => {
        // Mettez à jour le nom du mois lorsque l'index du mois change
        const updatedMonth = {
            ...currentMonth,
            name_month: moment().month(currentMonth.index).format("MMMM"),
        };
        setCurrentMonth(updatedMonth);
    }, [currentMonth.index]);

    const count_total_users_every_departments = countTotalUsers(filtredData);

    return (
        <ContainerFluid>
            <Container column styles={{ minWidth: "1440px" }}>
                <Toast
                    onStatusChange={() =>
                        setConfigToast({
                            visible: false,
                            content: "",
                            level: "warning",
                        })
                    }
                    level={configToast.level}
                    content={configToast.content}
                    visible={configToast.visible}
                />

                <Wrapper column>
                    <Flex column styles={{ gap: "8px" }}>
                        <HeaderText content="Suivi mensuelle" />

                        <ContentHeader fill column>
                            <Flex
                                fill
                                vAlign="center"
                                hAlign="center"
                                space="between"
                            >
                                <Flex
                                    vAlign="center"
                                    styles={{
                                        width: "800px",
                                    }}
                                    space="between"
                                >
                                    <SliderTabs
                                        fill
                                        defaultActiveIndex={activeTab}
                                        tabs={[
                                            "A valider",
                                            "Incomplètes",
                                            "Validées",
                                        ]}
                                        onChange={(e) => onActiveTabChanged(e)}
                                    />
                                    {/* slider month */}

                                    <SliderMonth
                                        month_name={currentMonth.name_month}
                                        onDecrement={() =>
                                            changeMonth("decrement")
                                        }
                                        onIncrement={() =>
                                            changeMonth("increment")
                                        }
                                        year={currentMonth.year}
                                        isLoading={isLoading || isFetching}
                                        badge_status={
                                            moment().month() ===
                                            currentMonth?.index
                                                ? "in_progress"
                                                : "default"
                                        }
                                    />
                                </Flex>
                                {/* skeleton */}
                                {activeTab !== 2 && (
                                    <Flex>
                                        {!isLoading && !isFetching ? (
                                            <TimeReportingStatus
                                                counter={data?.[
                                                    STATUS_TIME_REPORTING.at(
                                                        activeTab
                                                    )
                                                ]?.reduce((accu, curr) => {
                                                    return (
                                                        accu + curr.users.length
                                                    );
                                                }, 0)}
                                                label={
                                                    STATUS_COUNTER_LABEL[
                                                        STATUS_TIME_REPORTING.at(
                                                            activeTab
                                                        )
                                                    ]
                                                }
                                            />
                                        ) : (
                                            <Flex>
                                                <Skeleton animation="wave">
                                                    <Skeleton.Line width="120px" />
                                                </Skeleton>
                                            </Flex>
                                        )}
                                    </Flex>
                                )}
                            </Flex>
                            <HeaderTable vAlign="center">
                                {/* search bar  */}
                                <Flex
                                    styles={{
                                        minWidth: "276px",
                                    }}
                                >
                                    <SearchBarEmployeeList
                                        refetch_all_data_for_my_team={
                                            refetch_all_data_for_my_team
                                        }
                                        users={employees_and_teams}
                                        isLoading={is_loading_employees_teams}
                                        activeTab={activeTab}
                                        onChangeUser={(user_id, type) =>
                                            onChangeUser(
                                                user_id,
                                                type,
                                                data,
                                                setFiltredData,
                                                setActiveTab,
                                                addNewParam,
                                                onChangeSelectedUser
                                            )
                                        }
                                    />
                                </Flex>

                                <Thead
                                    space="between"
                                    styles={{
                                        minWidth: "909px",
                                    }}
                                    className="thead"
                                    fill
                                >
                                    {isLoadingData ? (
                                        <LoadingData />
                                    ) : (
                                        data?.weeks?.map((el, index) => {
                                            return (
                                                <WeekTableHeader
                                                    currentMonth={currentMonth}
                                                    day={el}
                                                    loading={isLoadingData}
                                                    index={index}
                                                    setHighlightedColumn={
                                                        setHighlightedColumn
                                                    }
                                                    highlightedColumn={
                                                        highlightedColumn
                                                    }
                                                    activeTab={activeTab}
                                                />
                                            );
                                        })
                                    )}
                                </Thead>
                                <Flex fill>
                                    <TotalHeaderText content="" />
                                </Flex>
                            </HeaderTable>
                        </ContentHeader>
                    </Flex>

                    {/* body Table  */}

                    <ContentBody column>
                        {/* <Row column> */}
                        <Flex
                            styles={{
                                backgroundColor: "white",
                                width: "328px",
                                padding: "12px 20px",
                            }}
                        >
                            <Checkbox
                                disabled={filtredData?.length ? false : true}
                                onChange={handleAllCheckbox}
                                label="Sélectionner tous les collaborateurs"
                                checked={
                                    count_total_users_every_departments ===
                                    userIdChecked?.length
                                        ? true
                                        : userIdChecked?.length > 0
                                        ? "mixed"
                                        : false
                                }
                            />
                        </Flex>

                        <Flex column>
                            {activeTab === 0 && (
                                <Flex column>
                                    {ConfirmationDialog && (
                                        <DialogCancelConfirmation
                                            open={ConfirmationDialog}
                                            cancelButton={{
                                                content: "Annuler",
                                                flat: true,
                                            }}
                                            confirmButton={{
                                                content: "Valider",
                                                flat: true,
                                                loading:
                                                    isLoadingValidation_or_RefuseTimeReporting,
                                            }}
                                            header="Voulez-vous vraiment valider les feuilles de temps ?"
                                            content={
                                                <Flex
                                                    hAlign="center"
                                                    column
                                                    gap="gap.small"
                                                >
                                                    <Text content="La saisie ne sera plus disponible. S’il y a une seconde validation, la feuille de temps sera envoyée au deuxième validateur s’il y’en a un." />
                                                    <Illustration
                                                        filename={
                                                            "time_reporting/time_reporting_empty_data.svg"
                                                        }
                                                        width="209px"
                                                    />
                                                </Flex>
                                            }
                                            onClose={() =>
                                                setConfirmationDialog(false)
                                            }
                                            onConfirm={Validate_time_reporting}
                                            width="566"
                                        />
                                    )}
                                    {RefuseDialog && (
                                        <DialogCancelConfirmation
                                            open={RefuseDialog}
                                            cancelButton={{
                                                content: "Annuler",
                                                flat: true,
                                            }}
                                            confirmButton={{
                                                content: "Refuser",
                                                flat: true,
                                                loading:
                                                    isLoadingValidation_or_RefuseTimeReporting,
                                            }}
                                            header="Voulez-vous vraiment refuser les feuilles de temps ?"
                                            content={
                                                <Flex hAlign="center" column>
                                                    <Text content="La ou les personnes recevront une notification, la saisie sera de nouveau disponible." />
                                                </Flex>
                                            }
                                            onClose={() =>
                                                setRefuseDialog(false)
                                            }
                                            onConfirm={Refuse_time_reporting}
                                            width="566"
                                        />
                                    )}
                                    <MainTable column className="main_table">
                                        <TimeReportToValidate
                                            tab={0}
                                            loading={isLoadingData}
                                            status={BADGE_STATUS.toValidate}
                                            users={filtredData}
                                            userIdChecked={userIdChecked}
                                            userIdToSend={userIdToSend}
                                            highlightedColumn={
                                                highlightedColumn
                                            }
                                            currentMonth={currentMonth}
                                        />
                                        {filtredData?.length === 0 &&
                                            data !== undefined && (
                                                <EmptyTable
                                                    actionText={"à approuver"}
                                                />
                                            )}
                                    </MainTable>

                                    <FooterButton
                                        vAlign="center"
                                        hAlign="end"
                                        gap="gap.small"
                                    >
                                        <ExportButton
                                            disabled={
                                                userIdChecked?.length
                                                    ? false
                                                    : true
                                            }
                                            onClick={() => ExportSelectedData()}
                                            isLoading={isDownloading}
                                        />
                                        <Button
                                            styles={
                                                userIdChecked?.length
                                                    ? { color: "#C4314B" }
                                                    : ""
                                            }
                                            disabled={
                                                userIdChecked?.length
                                                    ? false
                                                    : true
                                            }
                                            loading={
                                                isLoadingValidation_or_RefuseTimeReporting
                                            }
                                            onClick={() =>
                                                setRefuseDialog(true)
                                            }
                                            iconPosition="after"
                                            icon={<ClockDismiss24Regular />}
                                            text
                                            content="Refuser les feuilles de temps"
                                        />
                                        <Button
                                            disabled={
                                                userIdChecked?.length
                                                    ? false
                                                    : true
                                            }
                                            onClick={() =>
                                                setConfirmationDialog(true)
                                            }
                                            iconPosition="after"
                                            icon={
                                                <ClipboardCheckmark24Regular />
                                            }
                                            flat
                                            primary
                                            content="Valider les feuilles de temps"
                                        />
                                    </FooterButton>
                                </Flex>
                            )}
                            {activeTab === 1 && (
                                <Flex column>
                                    {RelanceDialog && (
                                        <DialogCancelConfirmation
                                            open={RelanceDialog}
                                            cancelButton={{
                                                content: "Annuler",
                                                flat: true,
                                            }}
                                            confirmButton={{
                                                content: "Relancer",
                                                flat: true,
                                                loading:
                                                    isLoadingValidation_or_RefuseTimeReporting,
                                            }}
                                            header="Voulez-vous vraiment Relancer ?"
                                            content={
                                                <Flex hAlign="center" column>
                                                    <Text content="La ou les personnes recevront une notification, la saisie sera de nouveau disponible." />
                                                </Flex>
                                            }
                                            onClose={() =>
                                                setRelanceDialog(false)
                                            }
                                            onConfirm={Relance_time_reporting}
                                            width="566"
                                        />
                                    )}
                                    <MainTable column>
                                        {filtredData?.length ? (
                                            <TimeReportToValidate
                                                userIdChecked={userIdChecked}
                                                userIdToSend={userIdToSend}
                                                loading={isLoadingData}
                                                users={filtredData}
                                                length={1000}
                                                status={BADGE_STATUS.Incomplete}
                                                highlightedColumn={
                                                    highlightedColumn
                                                }
                                                currentMonth={currentMonth}
                                                tab={1}
                                            />
                                        ) : (
                                            <EmptyTable
                                                actionText={"incomplète"}
                                            />
                                        )}
                                    </MainTable>
                                    <FooterButton
                                        vAlign="center"
                                        space="between"
                                        gap="gap.small"
                                    >
                                        <ExportButton
                                            disabled={
                                                userIdChecked?.length
                                                    ? false
                                                    : true
                                            }
                                            onClick={() => ExportSelectedData()}
                                            isLoading={isDownloading}
                                        />
                                        <Button
                                            loading={
                                                isLoadingValidation_or_RefuseTimeReporting
                                            }
                                            onClick={() =>
                                                setRelanceDialog(true)
                                            }
                                            // disabled={
                                            //     filtredData?.length
                                            //         ? false
                                            //         : true
                                            // }
                                            disabled={
                                                userIdChecked?.length
                                                    ? false
                                                    : true
                                            }
                                            iconPosition="after"
                                            icon={<SendIcon />}
                                            flat
                                            primary
                                            content="Relancer les feuilles de temps"
                                        />
                                    </FooterButton>
                                </Flex>
                            )}
                            {activeTab === 2 && (
                                <Flex column>
                                    <MainTable column>
                                        {filtredData?.length ? (
                                            <TimeReportToValidate
                                                loading={isLoadingData}
                                                activeTab={activeTab}
                                                users={filtredData}
                                                length={filtredData?.length}
                                                userIdChecked={userIdChecked}
                                                userIdToSend={userIdToSend}
                                                status={BADGE_STATUS.Validated}
                                                highlightedColumn={
                                                    highlightedColumn
                                                }
                                                currentMonth={currentMonth}
                                                tab={2}
                                            />
                                        ) : (
                                            <EmptyTable
                                                actionText={"validée"}
                                            />
                                        )}
                                    </MainTable>

                                    <FooterButton
                                        vAlign="center"
                                        hAlign="start"
                                        gap="gap.small"
                                    >
                                        <ExportButton
                                            disabled={
                                                userIdChecked?.length
                                                    ? false
                                                    : true
                                            }
                                            onClick={() => ExportSelectedData()}
                                            isLoading={isDownloading}
                                        />
                                    </FooterButton>
                                </Flex>
                            )}
                        </Flex>
                    </ContentBody>
                </Wrapper>
            </Container>
        </ContainerFluid>
    );
};

export default MyTeam;

const MainTable = styled(Flex)`
    max-height: 390px;

    overflow-x: hidden;
    overflow-y: scroll;
    margin-bottom: 100px;
`;
const FooterButton = styled(Flex)`
    position: fixed;
    bottom: 10px;
    min-width: 1430px;
    padding: 16px 16px;
    border-bottom: 1px solid #d1d1d1;
    background: #fff;
    box-shadow: 0px 6.4px 14.4px 0px rgba(0, 0, 0, 0.13),
        0px 1.2px 3.6px 0px rgba(0, 0, 0, 0.11);
`;

const ContentBody = styled(Flex)`
    /* background-color: #e8ebfa; */
    /* z-index: 2; */
`;

const TotalHeaderText = styled(Text)`
    color: #616161;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
`;

const HeaderText = styled(Text)`
    color: #242424;

    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    padding: 16px;
`;

const ContentHeader = styled(Flex)`
    z-index: 2;
    background: #fff;
    box-shadow: 0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.11),
        0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.07);
    /* height: 525px; */
    padding-bottom: 24px;
    padding: 16px 24px;
    gap: 16px;
`;

const HeaderTable = styled(Flex)`
    gap: 48px;
`;

const Thead = styled(Flex)``;
const Wrapper = styled(Flex)`
    .cell.highlight {
        background-color: #ebebeb;
        transition: all 0.3s;
    }
`;
